export const validationsConfig = [{
  name: 'firstName',
  valid: value => /^[\p{L}\p{M}]+([ \-'][\p{L}\p{M}]+)*$/u.test(value)
}, {
  name: 'lastName',
  valid: value => /^[\p{L}\p{M}]+([ \-'][\p{L}\p{M}]+)*$/u.test(value)
}, {
  name: 'salutation',
  valid: value => value?.length >= 1
}, {
  name: 'emailAddress',
  valid: value => /^[\w.%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i.test(value) && value.length > 0
}, {
  name: 'password',
  valid: value => /^\S$|^\S[ \S]*\S$/.test(value) && value.length > 0
}];
export const isPasswordValid = (password, confirmationPassword) => {
  const validations = {
    length: password?.length >= 8,
    upperCase: /[A-Z]/.test(password),
    lowerCase: /[a-z]/.test(password),
    specialChar: /[●!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]/.test(password),
    number: /\d/.test(password),
    whiteSpace: /^\S$|^\S[ \S]*\S$/.test(password)
  };
  const isValid = validations.length && validations.upperCase && validations.specialChar && validations.number && validations.whiteSpace && !!password && !!confirmationPassword && password === confirmationPassword;
  return {
    isValid,
    validations
  };
};
export const convertErrorTypeToCamelCase = errorType => {
  const splittedArray = errorType?.split('-');
  return splittedArray.reduce((error, word, index) => {
    const mutatedWord = index === 0 ? word : firstLetterUpperCase(word);
    return error + mutatedWord;
  });
};
export const firstLetterUpperCase = word => {
  return word[0].toUpperCase() + word.slice(1);
};
export const ERROR_TYPES = {
  emailAddress: ['invalid-credentials', 'unverified-customer', 'request-validation'],
  password: ['invalid-credentials', 'password-attempts-exceeded']
};